import 'components/carousels/JsCarousel.js';
import {
    OnNowCarouselPortraitBreakpoints,
    OnNowCarouselLandsCapeBreakpoints,
} from 'components/settings/BreakpointSettings';
import { formatEventTime } from 'helpers/dates';
import { ContentHighlightCarousel } from 'components/highlight/carousel/ContentHighlightCarousel';

export default function (customOptions = {}) {
    // sizes are 'small' or 'large' (default)
    let size = customOptions.size ? customOptions.size : 'large';
    // orientations are 'landscape' (default) or 'portrait'
    let orientation = customOptions.orientation ? customOptions.orientation : 'landscape';

    let wrapper = customOptions.parentContainer
        ? customOptions.parentContainer
        : $('.generic-carousel');

    let defaultOptions = {
        responsive:
            size == 'small' || orientation == 'portrait'
                ? OnNowCarouselPortraitBreakpoints
                : OnNowCarouselLandsCapeBreakpoints,
        zoomCarouselEffectDisabled: true,
    };

    wrapper.on('videoDataLoad', (e, result) => {
        result?.data?.forEach((item) => {
            if (item.startTimestamp) {
                const time = new Date(parseInt(item.startTimestamp));
                item.scheduleBadgeText = formatEventTime(time);
            }
        });
    });

    let endOptions = $.extend(defaultOptions, customOptions.options);
    new ContentHighlightCarousel(wrapper[0], endOptions);
}
